import { Node, mergeAttributes } from '@tiptap/core';

const ATTRIBUTE_NAME = 'data-html';

const encodeHtml = (value = '') => encodeURIComponent(value);
const decodeHtml = (value = '') => decodeURIComponent(value);

export default Node.create({
    name: 'vehicleBrochure',
    group: 'block',
    atom: true,
    draggable: true,
    selectable: true,

    addAttributes() {
        return {
            html: {
                default: '',
                parseHTML: (element) => decodeHtml(element.getAttribute(ATTRIBUTE_NAME) || ''),
                renderHTML: (attributes) => ({
                    [ATTRIBUTE_NAME]: encodeHtml(attributes.html || ''),
                }),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'vehicle-brochure',
            },
        ];
    },

    renderHTML({ node, HTMLAttributes }) {
        const attributes = mergeAttributes(HTMLAttributes);

        if (node?.attrs?.html) {
            attributes[ATTRIBUTE_NAME] = encodeHtml(node.attrs.html);
        }

        return ['vehicle-brochure', attributes];
    },

    addNodeView() {
        return ({ node }) => {
            const dom = document.createElement('div');

            dom.classList.add('vehicle-brochure-node');
            dom.dataset.vehicleBrochureNode = 'true';
            dom.innerHTML = node.attrs.html || '';

            return {
                dom,
            };
        };
    },
});
